import type { ProductFilterSchema } from '@coas/validators/const';

/**
 * Filter sections. `title` holds a message-id under productFilter.* namespace,
 * resolved by useTranslations in the consumer component.
 */
export const filterItems = [
    { key: 'brands', title: 'brands' },
    { key: 'colors', title: 'colors' },
    { key: 'sizes', title: 'sizes' },
    { key: 'price', title: 'price' },
] satisfies Array<{
    key: ProductFilterSchema;
    title: string;
}>;
